import React, { useEffect, useState } from "react";
import "./type-games-menu.scss";
import IconMenuCircle from "../../mui/JSXIcons/IconMenuCircle";
import { useTranslation } from "react-i18next";
import IconTg from "../../mui/JSXIcons/IconTg";
import IconBonus from "../../mui/JSXIcons/IconBonus";
import IconFavorite from "../../mui/JSXIcons/IconFavorite";
import IconFair from "../../mui/JSXIcons/IconFair";
import IconReload from "../../mui/JSXIcons/IconReload";
import { ENUM_GAME_TYPE, ENUM_LCS_NAME } from "../../../store/enums";
import { useSelector } from "react-redux";
import { useReadLocalStorage } from "usehooks-ts";
import ShowContainer from "../../mui/ShowContainer";
import { useAppSelector } from "../../../store/index.ts";
import IconWebCamera from "../../mui/JSXIcons/IconWebCamera.jsx";
import CustomCarousel from "../../mui/custom-carousel/CustomCarousel.jsx";
import useGetLinkCallback from "../../../hooks/other/useGetLinkCallback.js";
import { Link } from "react-router-dom";

export default function TypeGamesMenu({ activeTab }) {
  const { t } = useTranslation();
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";
  const botName = useSelector((state) => state.common.botName);
  const lang = useAppSelector((state) => state.common.lang);
  const isLsm = useSelector((state) => state.deviceSize.isLsm);
  const isDesktop = useSelector((state) => state.deviceSize.isDesktop);
  const isExtraSmall = useSelector((state) => state.deviceSize.isExtraSmall);
  const idProvidersLiveGame = useAppSelector((state) => state.games.idProvidersLiveGame);
  const isLiveGames = idProvidersLiveGame.length;
  const favoritesGames = useAppSelector((state) => state.games.favoriteGames);
  const historyGamesId = useAppSelector((state) => state.games.runningGamesId);
  const isBonusProvider = useAppSelector((state) => state.games.bonusProvider?.id);

  const [items, setItems] = useState([]);
  const checkActive = (tab) => (activeTab === tab ? "active" : "");
  const useGetLink = useGetLinkCallback();

  const favoriteLength = favoritesGames.length;
  const historyLength = historyGamesId.length;

  const casinoLink = start_r
    ? `https://t.me/${botName}?start_r=${start_r}`
    : `https://t.me/${botName}`;

  const getItemsBySize = () => {
    if (isExtraSmall) return 2;
    if (!isDesktop) return 3;
    if (isLsm) return 4;
  };
  const itemsBySize = getItemsBySize();

  useEffect(() => {
    const items = [
      { id: ENUM_GAME_TYPE.lobby, title: t("Lobby"), icon: <IconMenuCircle />, navigate: "/" },
      { id: ENUM_GAME_TYPE.hit, title: t("Hit"), icon: <IconFair />, navigate: "/games/hit" }
    ];

    const live = {
      id: ENUM_GAME_TYPE.live,
      title: t("Live Games"),
      icon: <IconWebCamera />,
      navigate: "/games/live"
    };

    const bonus = {
      id: ENUM_GAME_TYPE.bonus,
      title: t("Bonus Games"),
      icon: <IconBonus />,
      navigate: "/games/bonus"
    };

    const favorites = {
      id: ENUM_GAME_TYPE.favorites,
      title: t("Favorites Games"),
      icon: <IconFavorite />,
      navigate: "/games/favorites"
    };

    const history = {
      id: ENUM_GAME_TYPE.history,
      title: t("My game`s history"),
      icon: <IconReload />,
      navigate: "/games/history"
    };
    const casino = {
      id: "casino",
      title: t("Telegram casino"),
      icon: <IconTg />,
      link: casinoLink
    };

    if (isLiveGames) items.push(live);
    if (isBonusProvider) items.push(bonus);
    if (favoriteLength) items.push(favorites);
    if (historyLength) items.push(history);
    if (botName) items.push(casino);

    setItems(items);
  }, [lang, favoriteLength, historyLength, isLiveGames, botName]);

  const ButtonLink = ({ item }) =>
    item.navigate ? (
      <Link
        className={`type-game-item ${checkActive(item.id)}`}
        draggable="false"
        to={useGetLink(item.navigate)}>
        {item.icon}
        <span>{t(item.title)}</span>
      </Link>
    ) : (
      <a
        className={`type-game-item ${checkActive(item.id)}`}
        href={item.link}
        target="_blank"
        rel="noreferrer"
        draggable="false">
        {item.icon}
        <span>{t(item.title)}</span>
      </a>
    );

  return (
    <ShowContainer condition={items.length}>
      {isLsm ? (
        <CustomCarousel className="type-game-menu" items={itemsBySize}>
          {items.map((item, indx) => (
            <ButtonLink item={item} key={"lsm" + indx} />
          ))}
        </CustomCarousel>
      ) : (
        <nav className="type-game-menu">
          {items.map((item, indx) => (
            <ButtonLink item={item} key={indx} />
          ))}
        </nav>
      )}
    </ShowContainer>
  );
}
